import type { AxiosResponse } from "axios";
import axios from "axios";
import { appBaseUrl } from "../../config/apiConfig";
import type {
  ChatCompletionResponseObject,
  ChatCompletionsRequestObject,
} from "./types";

export const createChatCompletions = (
  postObj: ChatCompletionsRequestObject,
  url: string,
  options?: { signal?: AbortSignal },
): Promise<ChatCompletionResponseObject> => {
  return appBaseUrl
    .post(`${url}`, postObj, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};
